import type { FilterOption } from './PriceSimulation.types';
import type { SkuInstance } from './skuInstances';

const MAX_LISTED_PACKAGES = 3;

const nameKey = (name: string): string => name.trim().toLocaleLowerCase('sv');

export const formatPackageNames = (instances: SkuInstance[]): string => {
    const names = Array.from(new Set(instances.map((instance) => instance.packageName))).sort((a, b) => a.localeCompare(b, 'sv', { numeric: true, sensitivity: 'base' }));
    const listed = names.slice(0, MAX_LISTED_PACKAGES).join(', ');
    return names.length > MAX_LISTED_PACKAGES ? `${listed} +${names.length - MAX_LISTED_PACKAGES}` : listed;
};

export const buildProductOptions = (products: { sku: string; name: string }[], skuInstancesMap: Record<string, SkuInstance[]>): FilterOption[] => {
    const nameCounts = new Map<string, number>();
    products.forEach(({ name }) => nameCounts.set(nameKey(name), (nameCounts.get(nameKey(name)) ?? 0) + 1));
    return products.map(({ sku, name }) => {
        const description = formatPackageNames(skuInstancesMap[sku] ?? []);
        return {
            id: sku,
            name: (nameCounts.get(nameKey(name)) ?? 0) > 1 ? `${name} (${sku})` : name,
            ...(description !== '' && { description }),
        };
    });
};
